import config from 'config';

const LOAD = 'football/teamForm/LOAD';
const LOAD_SUCCESS = 'football/teamForm/LOAD_SUCCESS';
const LOAD_FAIL = 'football/teamForm/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: false,
          loaded: true,
          form: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, matchId) {
  return globalState.football
      && globalState.football.teamForm
      && globalState.football.teamForm[matchId]
      && globalState.football.teamForm[matchId].loading;
}

export function load(matchId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(config.api.football.loadTeamForm, {params: {match_id: matchId}}),
    matchId
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/teamForm.js